import React from 'react';
import { MinesRoundsTable } from './MinesRoundsTable';

export const MinesRoundsList: React.FC = () => {
  return <MinesRoundsTable />;
};
